import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=4476d145&scoped=true&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReviewCard.vue?vue&type=style&index=1&id=4476d145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476d145",
  null
  
)

export default component.exports